// Central config — the live ticketing app lives on a subdomain.
// All CTAs on this marketing site redirect here exactly (no path, no trailing slash).
export const APP_URL = 'https://app.eventsportal.live';

// Kept as a function for ergonomic import; always returns the bare app URL.
export const appLink = () => APP_URL;

// Contact is form-only. No support address is published here or in the app —
// every message goes through the form below, lands in support_tickets, and is
// answered from the admin inbox. Do not reintroduce a mailto anywhere on this
// site; /support is the URL both store listings point at and it has to stand on
// its own as a working form for someone with no account.
export const CONTACT_ENDPOINT = 'https://api.eventsportal.live/public/contact';

// Categories, matching the support_tickets.category check constraint and the
// list the in-app form offers. Anything else is filed as 'other' by the Worker.
export const CONTACT_CATEGORIES = [
    { value: 'tickets', label: 'A ticket I bought' },
    { value: 'payments', label: 'Payments & charges' },
    { value: 'account', label: 'Account & sign-in' },
    { value: 'organizer', label: 'Hosting an event' },
    { value: 'technical', label: 'Something is broken' },
    { value: 'appeal', label: 'Appeal a suspension' },
    { value: 'privacy', label: 'Privacy or data request' },
    { value: 'press', label: 'Press & partnerships' },
    { value: 'other', label: 'Something else' },
];
